import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { subscriptionStatusLabel } from '../../utils/subscription-pause.copy';

/**
 * Status pill for a membership (Active, Paused, Pause scheduled, Cancelling, ...).
 * Shared by the Customers → Subscriptions cards and the lane subscription popups.
 *
 * @selector app-subscription-status-tag
 * @input status - The membership's `display_status`.
 */
@Component({
  selector: 'app-subscription-status-tag',
  standalone: true,
  templateUrl: './subscription-status-tag.component.html',
  styleUrls: ['./subscription-status-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SubscriptionStatusTagComponent {
  @Input() status: string | null = null;

  get label(): string {
    return subscriptionStatusLabel(this.status);
  }

  get modifierClass(): string {
    return `subscription-status-tag subscription-status-tag--${this.status || 'expired'}`;
  }
}
